import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  ElementRef,
  HostListener,
  ViewContainerRef,
  ComponentFactoryResolver,
  Type
} from '@angular/core';
import { TabLink } from '@shared/interfaces/menu/tab-link.interface';
import { debounce } from '@shared/decorators/debounce.decorator';
import { MediaQuery } from '@shared/configs/media-query';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'content-with-tabs-v2',
  templateUrl: './content-with-tabs-v2.component.html',
  styleUrls: ['./content-with-tabs-v2.component.scss']
})
export class ContentWithTabsV2Component implements OnInit {
  maxTabsWidth: number;
  _componentTemplate: any;

  @Input() tabLinks: TabLink[];
  @Input() tabsDescription: string;
  @Input() tabsDescriptionTemplate: TemplateRef<any>;
  @Input() tabsTemplate: TemplateRef<any>;
  @Input() contentTemplate?: TemplateRef<any>;
  @Input() hideTopTabIconOnMobile: boolean = false;
  @Input() selectTabsOnMobile: boolean = false;
  @Input() bottomBar: boolean = false;
  @Input() customActivePaths?: boolean = false;
  @Input()
  set componentTemplate(component: Type<unknown>) {
    this._componentTemplate = component;
    this.loadDynamicComponent(component);
  }

  get componentTemplate() {
    return this._componentTemplate;
  }

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  @ViewChild('tabs') tabs: ElementRef;
  @ViewChild('dynamicContentContainer', { read: ViewContainerRef, static: true })
  dynamicContentContainer!: ViewContainerRef;

  ngOnInit(): void {
    this.scroll();
    this.resize();
  }

  private loadDynamicComponent(component: Type<unknown>) {
    if (this.dynamicContentContainer) {
      this.dynamicContentContainer.clear();
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
      this.dynamicContentContainer.createComponent(componentFactory);
    }
  }

  @HostListener('window:scroll')
  @debounce(13)
  scroll() {
    if (!this.tabs?.nativeElement) return;

    const pos = this.tabs ? this.tabs.nativeElement.parentElement.getBoundingClientRect() : 0;
    const posTop = pos.y + this.tabs.nativeElement.parentElement.ownerDocument.defaultView.pageYOffset;
    const windowsScrollTop = document.querySelector('.base-panel').scrollTop + 10;
    if (posTop + 1 < windowsScrollTop && window.innerWidth > MediaQuery.MD) {
      this.tabs.nativeElement.style.width = this.maxTabsWidth + 'px';
      this.tabs.nativeElement.classList.add('sticky-top');
      this.tabs.nativeElement.classList.add('position-fixed');
    } else {
      this.tabs.nativeElement.classList.remove('sticky-top');
      this.tabs.nativeElement.classList.remove('position-fixed');
      this.tabs.nativeElement.style.width = null;
    }
  }

  @HostListener('window:resize')
  @debounce(30)
  resize() {
    this.maxTabsWidth = this.tabs.nativeElement.parentElement.offsetWidth - 25;
    this.scroll();
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
}
